<div [innerHTML]="helpText" *ngIf ="helpText?.length > 0"></div>
   
